
import React from 'react';
import Header from './Header';
import Navbar from './Navbar';

const MainLayout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#f7f7f7' }}>
            <Header />
            {/* <Navbar /> */}
            <main className="flex-1 flex flex-col min-h-0 w-full">
                {children}
            </main>
            <footer className="bg-white border-t border-gray-100 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-400 text-[11px] tracking-[0.12em] font-poppinsLight">
                    <p>&copy; {new Date().getFullYear()} AXONALL Luxury Travel. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default MainLayout;
